import { Error } from '../error';

export type LoginCrossPlatformAction = (
	request: RemoteLoginCrossPlatformRequest,
) => Promise<RegisterResponse>;

export interface RemoteLoginCrossPlatformRequest {
	sessionId: string;
	password: string;
}

export interface LoginCrossPlatformActionResponseSuccess {
	playerId: number;
	redirectUrl: string;
}

export interface ValidationErrorResponse {
	errors: Map<string, Error[]>;
}

interface ResponseWithStatus<T> {
	status: number;
	data: T;
}

export type RegisterResponse =
	| ResponseWithStatus<LoginCrossPlatformActionResponseSuccess>
	| ResponseWithStatus<ValidationErrorResponse>;
